import { Body, Classes, IBodyProps } from '@pinpointhq/thumbtack';
import * as React from 'react';
import { simpleFormat } from '../../utilities/simpleFormat';
import { sanitizeContentStripAll } from '../utilities/sanitizeContentStripAll';

export interface ISanitizedRunningTextProps extends IBodyProps {
  text: string;
}

export function SanitizedRunningText({ text, ...props }: ISanitizedRunningTextProps) {
  return (
    <Body
      className={Classes.RUNNING_TEXT}
      dangerouslySetInnerHTML={{ __html: simpleFormat(sanitizeContentStripAll(text)) }}
      {...props}
    />
  );
}
